module.exports = __webpack_public_path__ + "static/media/facebook-capi-gtm.143e33a4.md";